import {selectJobDetails} from 'components/customer/Confirmation/store/confirmationSlice';
import {JobForm} from 'components/customer/Job/entity/JobForm';
import {DispatchMethod} from 'hooks/Job/Job';
import {User} from 'components/customer/Auth/store/userSlice';
import {useAppContext} from 'contexts/ApplicationContext';
import {useAppSelector} from 'store/customer';

// checkout needs a complete delivery address unless the order is picked up.
// jobDetails is reported by the freight tab, undefined means the freight tab
// is not in use so there is nothing to check
export const isDeliveryAddressMissing = (jobDetails?: JobForm) => {
    if (!jobDetails) return false;

    if (
        jobDetails.dispatch != undefined &&
        Number(jobDetails.dispatch) == DispatchMethod.PICKUP
    ) {
        return false;
    }

    return (
        !jobDetails.street ||
        !jobDetails.suburb ||
        !jobDetails.postcode ||
        !jobDetails.state
    );
};

export const selectDisableCheckout = (
    state: Parameters<typeof selectJobDetails>[0]
) => isDeliveryAddressMissing(selectJobDetails(state));

// the manufacturer requires a requested delivery date and none is picked on the
// freight tab. same as above, undefined jobDetails means nothing to check
export const isRequestedDeliveryDateMissing = (
    jobDetails?: JobForm,
    userProfile?: Partial<User>
) =>
    !!jobDetails &&
    !!userProfile?.allowDeliveryDateRequest &&
    !!userProfile?.requireDeliveryDateRequest &&
    !jobDetails.requestedDeliveryDate;

// checkout waits for a delivery address and, when required, a delivery date
export const useDisableCheckout = () => {
    const {userProfile} = useAppContext();
    const jobDetails = useAppSelector(selectJobDetails);

    return (
        isDeliveryAddressMissing(jobDetails) ||
        isRequestedDeliveryDateMissing(jobDetails, userProfile)
    );
};
